<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <!-- <b-card-header header-tag="header" class="p-1" role="tab">Aceptar términos y condiciones</b-card-header> -->
      <b-card-body>
        <div class="text-center">
          <img src="@/assets/iconTC.png" height="200px" />
        </div>
        <div class="col-md-12 text-center" style="margin-top: 20px">
          <div>Necesitamos que aceptes los términos y condiciones para continuar</div>
          <div class="resimple-switch" style="margin-top: 20px; margin-bottom: 30px">
            <label class="switch">
              <input type="checkbox" v-model="AcceptTermsAndConditionsCheckValue" />
              <span class="slider round" />
            </label>
            <div><a
                :href="LegalesUrl"
                target="_blank"
              >Acepto Términos y Condiciones</a></div>
          </div>
          <div v-if="MustAcceptPEP">
            <div class="form-group" style="text-align:center;margin-bottom: 0.5px;">
              <label class="text-center text-muted">
                <small>
                  ¿Sos una persona
                  <br />expuesta políticamente?
                </small>
                <a
                  slot="title"
                  @click="openModalPersonExpose"
                  class="btn btn-sm btn-icon-only text-blue"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="fas fa-question-circle"></i>
                </a>
              </label>
            </div>
            <div class="form-group" style="text-align:center;margin-bottom:15px;">
              <input
                type="radio"
                style="margin-right: 7px;"
                name="chexposed"
                id="no"
                value="false"
                v-model="PoliticallyExposedPerson"
              />
              <label class="form-check-label" style="margin-right:20px;" for="no">NO</label>
              <input
                type="radio"
                style="margin-right: 7px;"
                name="chexposed"
                id="yes"
                value="true"
                v-model="PoliticallyExposedPerson"
              />
              <label class="form-check-label" style="margin-right:20px;" for="yes">SI</label>
            </div>
          </div>
          <b-button
            class="btn btn-danger"
            @click="Continue()"
            :disabled="!AcceptTermsAndConditionsCheckValue"
          >Continuar</b-button>
        </div>
      </b-card-body>
    </b-card>
    <contact-help-desk ref="contact-help-desk" />
    <modal :show.sync="showModalPersonExpose">
      <div>
        <label
          class="modal-title"
        >Una persona expuesta políticamente (PEP) es aquella persona que tiene (o tuvo) una función pública relevante, o que mantiene algún tipo de relación con personas en una función pública relevante."</label>
      </div>
    </modal>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  components: {},
  data() {
    return {
      LegalesUrl: "",
      MustAcceptPEP: false,
      PoliticallyExposedPerson: false,
      showModalPersonExpose: false,
      AcceptTermsAndConditionsCheckValue: false
    };
  },
  methods: {
    Continue() {
      let context = this;

      if (!context.AcceptTermsAndConditionsCheckValue) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "Debe aceptar los términos y condiciones",
          context
        );
        return;
      }

      axiosHelpers.axiosPost(
        "Account/AceptTermsAndConditions",
        {
          Accept: context.AcceptTermsAndConditionsCheckValue,
          MustAcceptPEP: context.MustAcceptPEP,
          AcceptPEP: context.PoliticallyExposedPerson
        },
        context,
        function(data) {
          context.$store.commit("setMustAcceptPEP", true);

          context.$store.commit(
            "setTermsAndConditionsAccepted",
            context.AcceptTermsAndConditionsCheckValue
          );

          context.$router.push("dashboard");
        }
      );
    },
    openModalPersonExpose() {
      let context = this;
      context.showModalPersonExpose = true;
    }
  },
  beforeMount() {
    let context = this;
    context.LegalesUrl = context.$store.getters.SiteUrl + /legales/;
    context.MustAcceptPEP =
      context.$store.getters.MustAcceptPEP;
  }
};
</script>
